module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point4_1-fd6c2930847cee0e9aa83a68aa638aa9.jpg";